'use client'
import { Button, ModalProps } from "@heroui/react"
import { useTranslations } from "next-intl"
import { ArrowUpRight } from "@/ui/icons/ArrowUpRight"
import { PerkExclusive } from "@/ui/icons/PerkExclusive"
import { PerkMemory } from "@/ui/icons/PerkMemory"
import { PerkModel } from "@/ui/icons/PerkModel"
import { PerkItem, PerkPromptModal } from "@/ui/PerkPromptModal"
import { useContinuePayment } from "./useContinuePayment"

const PERKS = [
  { Icon: PerkMemory, labelKey: "pricing.perkLongTermMemory" },
  { Icon: PerkModel, labelKey: "pricing.perkMemberOnlyModel" },
  { Icon: PerkExclusive, labelKey: "pricing.perkMemberExclusives" },
] as const

export default ({
  onViewPlans,
  ...props
}: Omit<ModalProps, "children"> & {
  onViewPlans: () => void
}) => {
  const t = useTranslations()
  const { continuePayment, isLoading, dialogs } = useContinuePayment()

  return (
    <>
      <PerkPromptModal
        title={t("pricing.premiumNotActiveTitle")}
        subTitle={t("pricing.premiumNotActiveDesc")}
        perks={PERKS.map(({ Icon, labelKey }) => (
          <PerkItem key={labelKey} icon={Icon}>{t(labelKey)}</PerkItem>
        ))}
        {...props}
      >
        {(onClose) => (
          <>
            <Button
              fullWidth
              radius="full"
              isLoading={isLoading}
              className="mt-6 h-11 bg-gradient-to-l from-gradient-purple2 to-gradient-blue2 text-[16px] font-medium tracking-[-0.3px] text-white"
              onPress={() => {
                if (!continuePayment()) {
                  onViewPlans()
                  onClose()
                }
              }}
            >
              {t("pricing.continuePayment")}
            </Button>

            <button
              type="button"
              className="mt-4 flex items-center justify-center gap-0.5 text-[12px] font-medium leading-4 tracking-[-0.3px] text-black/70"
              onClick={() => {
                onClose()
                onViewPlans()
              }}
            >
              {t("pricing.viewAllPlans")}
              <ArrowUpRight width={16} height={16} className="size-4 opacity-70" />
            </button>
          </>
        )}
      </PerkPromptModal>
      {dialogs}
    </>
  )
}
